import { getStaticConfig } from './getStaticConfig';
import type { Application } from './session/application/types';

type GetApplication = () => Application;
export const getApplication: GetApplication = () => {
  const config = getStaticConfig();

  return config?.application?.applicationId ?? 'UNKNOWN';
};
